import { GlButton } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'EmojiGroup',
    components: {
        GlButton
    },
    props: {
        emojis: {
            type: Array,
            required: true
        },
        renderGroup: {
            type: Boolean,
            required: true
        }
    },
    emits: [
        'emoji-click'
    ],
    methods: {
        clickEmoji (emoji) {
            this.$emit('emoji-click', emoji);
        }
    }
};
